import { GetterTree } from 'vuex';
import * as types from '@webparts/store/types'

export default <GetterTree<webpartv3.state.WebpartsState, RootState>>{
    [types.WEBPART_UNREADMAIL_DATA](state) {
        return state.unreadMails;
    },
    
    [types.WEBPART_UNREADMAIL_COUNT_DATA](state) {
        return state.unreadMailCount;
    },

    [types.WEBPART_CALENDARFOLDER_DATA](state) {
        return state.calendarFolders;
    },
    
    [types.WEBPART_CALENDARMONTHLYEVENT_DATA](state) {
        return state.monthlyEvents;
    },

    [types.WEBPART_CALENDARDAILYEVENT_DATA](state) {
        return state.dailyEvents;
    },

    [types.WEBPART_COMMONDATA_MOUNTED](state) {
        return state.infoMounted;
    },

    [types.WEBPART_CALENDARTODAYEVENT_DATA](state) {
        return state.todayEvents;
    },
};
